import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import Table from "../../../../../../components/Table";
import BaseListPage from "../../../../../../base/BaseListPage";
import ServiceRecordPresenter from "./ServiceRecordPresenter";
import { Button, dialog, printComponent } from "nq-component";
import InputFactory from "../../../../../../components/InputFactory";
import { DialogConfirmation } from "../../../../../../components/common/Converter";
import React from "react";
import PrintServiceRecord from "./PrintServiceRecord/PrintServiceRecord";
import CardView from "../../../../../../components/common/CardView";
import { renderToStaticMarkup } from "react-dom/server";
// import ServiceRecordPresenter from "./ServiceRecordPresenter";

class ServiceRecord extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ServiceRecordPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      initialData: [],
      objects: [],
      object: {},
      count: 0,
      limit: 10,
      current: 1,
      rawExcelData: [],
    };
    this.contractPDF = React.createRef();
    this.fileInputRef = React.createRef();
  }

  // PrintObjects(objects) {
  //   console.log("OBJ: ", objects);
  //   this.setState({ printObject: objects });
  // }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.allowance)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.allowance)
      );
      // console.log("NEWOBJ:", newObjects);
      if (newObjects.length > 0) {
        localStorage.setItem("Loans", JSON.stringify(newObjects));
      }
    }
  }

  getCurrent() {
    return this.props.object.id;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const email = this.props.object.id;
    const newObject = await findObjectUseCase().execute(
      this.getCollectionName(),
      {
        where: { empID: email },
      }
    );

    this.setState({
      initialData: newObject,
    });
  }

  getCollectionName() {
    return "service_record";
  }
  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  generateCSV(objects) {
    this.presenter.getGenerateCSV();
  }

  handleEditData(data) {
    console.log("DATA: ", data);
    dialog.fire({
      html: (
        <div className="p-2">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.presenter.handleConfirmBtn(data);
            }}
          >
            <div className="row">
              <h4>Edit Cause</h4>
              <hr />
              <div className="pe-3 ps-3 pb-3">
                <label className="mb-2 fs-sm">
                  From <span className="text-danger">*</span>
                </label>
                <InputFactory
                  type="Date"
                  field="from"
                  object={data}
                  onChange={(val) => (data.from = val)}
                  required
                />
                <label className="mb-2 fs-sm">
                  To <span className="text-danger">*</span>
                </label>
                <InputFactory
                  type="Date"
                  field="to"
                  object={data}
                  onChange={(val) => (data.to = val)}
                  required
                />
                <label className="mb-2 fs-sm">
                  Cause <span className="text-danger">*</span>
                </label>
                <InputFactory
                  type="Text"
                  field="collection"
                  defaultValue={data?.cause}
                  onChange={(val) => (data.cause = val)}
                  required
                />
                <label className="mb-2 fs-sm">Remarks</label>
                <InputFactory
                  type="Text"
                  field="collection"
                  defaultValue={data?.remarks}
                  onChange={(val) => (data.remarks = val)}
                />
                {data.leave && data.leave.length > 0 && (
                  <>
                    <label className="mb-2 mt-1 fs-sm">Leave</label>
                    {data.leave.map((item, index) => {
                      return (
                        <InputFactory
                          key={index} // Key is necessary for rendering dynamic elements
                          className="mb-2"
                          type="String"
                          defaultValue={item}
                          onChange={(val) => {
                            const updatedLeave = [...data.leave]; // Make a copy of the leave array
                            updatedLeave[index] = val; // Modify the item at the specific index

                            // Filter out empty values
                            const filteredLeave = updatedLeave.filter(
                              (leaveItem) => leaveItem !== ""
                            );
                            data.leave = filteredLeave; // Set the updated array without empty values
                          }}
                        />
                      );
                    })}
                  </>
                )}
              </div>
              {/* <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to proceed.
            </p> */}
              <hr />
            </div>

            <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
              <Button
                className="btn btn-light fs-sm"
                type="button"
                onClick={() => dialog.close()}
              >
                Cancel
              </Button>
              <Button className="btn btn-primary" type="submit">
                Confirm
              </Button>
            </div>
          </form>
        </div>
      ),
      footer: false,
    });
  }

  handleDeleteData(data) {
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    return (
      <>
        <div className="m-4">
          {/* <div className="d-none">
            <div ref={this.contractPDF} id="contractPDF">
              <PrintServiceRecord
                objects={this.state.objects}
                object={this.props.object}
                // vacationLeave={this.state.vacationLeave}
                // sickLeave={this.state.sickLeave}
              />
            </div>
          </div> */}
          <div className="row">
            <div className="col-lg-12 p-2">
              <CardView>
                <div className="d-flex justify-content-end gap-2">
                  <div className="d-flex gap-2">
                    <input
                      type="file"
                      ref={this.fileInputRef}
                      accept=".xlsx, .xls"
                      className="form-control"
                      onChange={(e) =>
                        this.presenter.importDataIntoCSV(e, this.props.object)
                      }
                    />
                    <button
                      onClick={() =>
                        this.presenter.handleImportData(this.state.rawExcelData)
                      }
                      disabled={this.state.rawExcelData.length === 0}
                      type="button"
                      className="btn btn-primary fs-sm"
                    >
                      Import
                    </button>
                  </div>
                  <button
                    onClick={() => this.presenter.handlePrintData(objects)}
                    type="button"
                    className="btn btn-primary fs-sm"
                  >
                    Print PDF
                  </button>
                  <button
                    onClick={() => this.generateCSV(objects)}
                    type="button"
                    className="btn btn-primary fs-sm"
                  >
                    Export CSV
                  </button>
                </div>
              </CardView>
            </div>
          </div>

          <Table
            objectId={this.handleDeleteData.bind(this)}
            refetch={this.refetchData.bind(this)}
            objectData={this.handleEditData.bind(this)}
            progress={loading}
            fields={schema.fields}
            objects={objects}
            collection={schema}
            count={count}
            limit={limit}
            actionsList={[
              {
                label: <i className="bi bi-pencil-square" />,
                actionType: "object",
              },
              {
                label: <i className="bi bi-trash" />,
                actionType: "delete",
              },
            ]}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["id", "createdAt", "updatedAt", "employee", "email"]
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
export default ServiceRecord;
